import { constants as config } from '@config';
import BaseView from './base';
import searchOptionsTemplate from './search-options.hbs';
import detailsTemplate from './search-results/mls-details.hbs';
import mlsSearchResults from './mls-search-results';
import restrictionFacade from '../../../facade/restrictions/restrictions';
import designFacade from '../../../facade/design/design';

module.exports = BaseView.extend({
  type: 'mls',
  placeHolderUrl: 'https://static.inkive.com/assets/img/placeholders/imageplaceholder_new.svg',
  addedThumbnails: [],

  thumbSize: {
    width: 90,
    height: 90
  },

  events: _.extend({
    'click .item button': 'openPropertyDetails',
    'click .items-container .header span': 'clickItemsContainerHeader',
    'keyup input[name=mls-details-search]': 'searchMLSDetails',
    'click input[name=mls-details-search]': 'searchMLSDetails',
    'click .texts-header': 'showSearchBox',
    'click .images-header': 'showSearchBox',
    'click .back-link': 'closeDetails'
  }, BaseView.prototype.events),

  initialize: function () {
    _.bindAll(this, 'clickItemsContainerHeader', 'showPropertyItems', 'loginSuccessfullCallback');
    this.server = 'https://api.photodexia.com/giles/mls/search';

    BaseView.prototype.initialize.call(this);

    if (INKIVE.C.BOOK.external_reference) {
      this.preselected = true;
      this.selectOption(this.getSearchOptions().find('[data-key="key"]'));
      const $searchInput = this.$el.siblings('.search-container').find('input');
      $searchInput.val(INKIVE.C.BOOK.external_reference);
      this.search($searchInput);
    }
  },

  search: function ($searchInput) {
    this.addedThumbnails = [];
    BaseView.prototype.search.call(this, $searchInput);
  },

  closeDetails: function (event) {
    const $backButton = $(event.target);
    $backButton.closest('.inner-tabs').find('.search-options').css('display', 'none');
  },

  searchClickEvent: function (event) {
    this.$searchOptions && this.$searchOptions.toggle();
  },

  selectSearchOptionEvent: function (event) {
    const $target = $(event.currentTarget);
    const $options = this.getSearchOptions().find('> div');

    $target.is($options) && this.selectOption($target, $options);
    $options.closest('.search-container').children('input').focus();

    $options.closest('.search-options').css('display', 'none');
  },

  selectOption: function ($target, $options) {
    $options = $options || this.getSearchOptions().find('> div');
    const $input = this.getSearchOptions().siblings('input');
    let $option = $options.find('.desygner-icon-check');

    if (!$option.length) {
      $option = $('<i class="desygner-icon-check"></i>');
    }

    $options.removeClass('selected');
    $option.prependTo($target);
    $target.addClass('selected');

    $input.attr('placeholder', $target.text().trim());
  },

  getSearchOptions: function () {
    if (!this.$searchOptions) {
      this.$searchOptions = $(searchOptionsTemplate({ type: 'mls', isMls: true }));
    }

    return this.$searchOptions;
  },

  getSearchUrl: function (val) {
    let url = this.server;
    const searchType = this.getSearchOptions().find('.selected').data('key');

    url += '?search_type=' + (searchType || 'mls_number');
    url += '&search_key=' + encodeURI(val);
    url += '&limit=10&offset=';

    return url;
  },

  mapResult: function (item) {
    return mlsSearchResults.mapResult(item);
  },

  addThumbnail: function (item) {
    if (_.includes(this.addedThumbnails, item.id)) {
      return;
    }

    const imageLoadedCallback = _.bind(function (status) {
      item.thumbnail = status === INKIVE.C.Status.success ? item.thumbnail : this.placeHolderUrl;
      BaseView.prototype.addThumbnail.call(this, item);
      this.$el.find('[data-id=' + item.list_key + ']').data('item', item);
      this.addedThumbnails.push(item.id);

      if (this.preselected) {
        this.selectOption(this.getSearchOptions().find('[data-key="address"]'));
        this.$el.find('[data-id=' + item.list_key + ']').find('button').click();
        this.preselected = false;
      }
    }, this);

    INKIVE.ImagesFactory.smartLoad(item.thumbnail, this.thumbSize, imageLoadedCallback, true);
  },

  openPropertyDetails: function (event) {
    const $target = $(event.currentTarget);
    this.itemDetails = $target.closest('.item').data().item;
    const $detailsContainer = $target.closest('.mls-content').siblings('.mls-details');

    this.checkCanReplace();
    $detailsContainer.html(detailsTemplate({
      item: this.itemDetails,
      canUseImages: this.canUseImages,
      canUseText: this.canUseText
    }));
    $detailsContainer.find('.antiscroll-wrap').antiscroll();

    $detailsContainer.css('left', 0);
    $detailsContainer.find('.back-link').on('click', function () {
      INKIVE.SettingsFactory.set({ external_reference: null }).then(_.bind(function () {
        INKIVE.C.BOOK.external_reference = null;
      }, this));

      $detailsContainer.css('left', 315);
    });

    this.clickItemsContainerHeader();
    INKIVE.SettingsFactory.set({ external_reference: this.itemDetails.list_key }).then(_.bind(function () {
      INKIVE.C.BOOK.external_reference = this.itemDetails.list_key;
    }, this));
  },

  checkCanReplace: function () {
    this.canUseImages = restrictionFacade.isFunctionalityAllowed('image_add') ||
      restrictionFacade.isFunctionalityAllowed('image_content') || canUse('image');
    this.canUseText = restrictionFacade.isFunctionalityAllowed('text_add') || canUse('text');

    function canUse (type) {
      const tool = INKIVE.Tool.getInstance();
      const elems = tool.editor.canvas.getSelectedElems();

      if (elems.length === 1 && designFacade.get(elems[0].id).type === type) {
        const restrictionName = type === 'text' ? 'text_change_content' : 'image_content';

        return restrictionFacade.isActionAllowed(restrictionName, elems[0].id) ? 'onlyReplace' : false;
      }
    }
  },

  clickItemsContainerHeader: function (event) {
    const defaultHeader = this.$el.find('.mls-details').find(this.canUseImages ? '.images-header' : '.texts-header');
    const $target = event ? $(event.currentTarget) : defaultHeader;

    if ($target.is('.active')) {
      return;
    }

    $target.siblings().removeClass('active');
    $target.addClass('active');

    this.showPropertyItems($target.data('key'));
  },

  showPropertyItems: function (tab) {
    this.selectedTab = tab;
    const $parent = this.$el.find('.mls-details').find('.items-content');
    let $container = $parent.find('.' + tab);

    $parent.find('>div').hide();

    if ($container.length) {
      $container.show();
      tab === 'images' && $container.find('.thumbnail-wrapper').masonry(config.sidebar.thumbnail.masonryConfig);
      return;
    }

    $container = $('<div class="' + tab + '"/>').appendTo($parent);

    INKIVE.Modal.loader($container);
    this.$el.find('[data-search-filter]').show();
    mlsSearchResults['showProperty' + tab.charAt(0).toUpperCase() + tab.slice(1)]($container, this);
  },

  searchMLSDetails: function (event) {
    const $target = $(event.currentTarget);
    const val = $target.val();

    event.key === 'Enter' && event.preventDefault();

    this.$el.find('[data-search-filter]').toggle(!val);
    val && this.$el.find('[data-search-filter*=' + val + ']').show();

    this.$el.find('.images').find('.thumbnail-wrapper').masonry(config.sidebar.thumbnail.masonryConfig);
    this.refreshAntiscroll();
  },

  showSearchBox: function (event) {
    const $target = $(event.currentTarget);
    const $search = $target.closest('.antiscroll-inner').find('.search-container');

    if ($target.is('span.texts-header')) {
      $target.closest('.mls-details').find('.search-options-container').remove();
      $target.closest('.search-options-container').find('.search-options').css('display', 'none');
    }
    $search.toggleClass('search-container-show');
  },

  closeSearchEvent: function (event) {
    BaseView.prototype.closeSearchEvent.call(this, event);
    this.addedThumbnails = [];
    INKIVE.C.BOOK.external_reference = null;
    this.preselected = false;
  },

  loginSuccessfullCallback: function (modal, response) {
    modal.close();
    INKIVE.Modal.togglePageLoader(false);
    INKIVE.C.USER.kw_sso_token = response.access_token;
    this.search(this.$el.siblings('.search-container').find('[name=search]'));
  }
});
